import { ADMIN_SCOPED_ROLES, getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { IOneReport } from './types/IOneReport';

interface IUpdateOneReportNote {
  note: string;
}

// Admin/SuperAdmin/OrganizationAdmin use the dedicated `/admin/one_reports/...`
// router (inline role + org gates). Other staff roles use their scoped prefix;
// Patient/Provider fall through to the unprefixed route.
export const addOneReportInternalNote = async (
  one_report_id: string,
  payload: IUpdateOneReportNote,
  userRole?: string,
): Promise<IOneReport> => {
  const url =
    userRole && ADMIN_SCOPED_ROLES.has(userRole)
      ? `/admin/one_reports/${one_report_id}/internal_notes`
      : `${getStaffScopedApiPrefix(userRole)}/one_reports/${one_report_id}/internal_notes`;
  const { data } = await client.post<IOneReport>(url, payload);

  return data;
};
